import styled from 'styled-components';
import LeftArrow from '../../../assets/svg/LeftArrow';
import RightArrow from '../../../assets/svg/RightArrow';
import CatalogCard from '../../../components/CatalogCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import React, { useRef, useState } from 'react';
import '../../../assets/style.css';
import { PUBLIC_IMAGES_REPO } from '../../../../../utils/Constants';

const Image1 = `${PUBLIC_IMAGES_REPO}/catalog-image-1.webp`;
const Image2 = `${PUBLIC_IMAGES_REPO}/radient_blooms.webp`;
const Image3 = `${PUBLIC_IMAGES_REPO}/pitcher_of_pink.webp`;
const Image4 = `${PUBLIC_IMAGES_REPO}/pink_petals.webp`;
const Image5 = `${PUBLIC_IMAGES_REPO}/sunny_seplendor.webp`;
const Image6 = `${PUBLIC_IMAGES_REPO}/natural_elegance_arrangement.webp`;
const Image7 = `${PUBLIC_IMAGES_REPO}/seasonal_garden_harmony.webp`;
const Image8 = `${PUBLIC_IMAGES_REPO}/woodland_serenity_bouquet.webp`;
const Image9 = `${PUBLIC_IMAGES_REPO}/rustic_elegance_delight.webp`;
const Image10 = `${PUBLIC_IMAGES_REPO}/blooms_of_joyful_abundance.webp`;

const Wrapper = styled.section`
  background: var(--BG-Color, #f2f2f2);

  .container {
    max-width: 1440px;
    padding: 6.25rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  .header {
    .slider-buttons {
      position: absolute;
      right: 10%;
      top: 9.425rem;
    }

    h2 {
      color: var(--font-color-font-1, #1b131f);
      font-family: Instrument Sans;
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px;
      text-align: center;
    }

    p {
      color: var(--font-color-font-1, #1b131f);
      text-align: center;
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
    }
  }

  .card-container {
    margin: 3rem 0;
    // display: flex;
    // align-items: flex-start;
    gap: 24px;
    // align-self: stretch;
    width: 100%;
  }

  .action-button {
    display: flex;
    padding: 19px 30px 19px 36px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    border: 2px solid var(--primary-primary-600-f, #62aa48);
    background: var(--primary-primary-600-f, #62aa48);
    color: var(--font-color-font-4, #fff);
    text-align: center;
    margin-top: 50px;
    font-family: Instrument Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
  }

  @media screen and (max-width: 1024px) {
    .container {
      padding: 4.25rem;
    }

    .header {
      .slider-buttons {
        position: absolute;
        right: 10%;
        top: 8rem;
      }

      h2 {
        font-size: 45px;
        line-height: 58px;
      }

      p {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      padding: 4rem 1.25rem 2rem 1.25rem;
    }

    .header {
      .slider-buttons {
        display: none;
      }

      h2 {
        font-size: 32px;
        line-height: 40px;
      }

      p {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .card-container {
      margin: 1.5rem 0;
      gap: 16px;
    }
  }
`;

const products = [
  {
    img: Image1,
    title: 'Bejeweled Beauty',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'Passionately pink! This bouquet hot pink rose and dark red spray rose',
    price: '$39.99',
  },
  {
    img: Image2,
    title: 'Radient Blooms Delight',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      "Get ready to be swept away by a burst of vibrant colors and nature's beauty with our cheerful floral arrangement. Pink asiatic lilies, pink roses, fuchsia stock, white daisy spray chrysanthemums, and raspberry sinuata statice come together in a joyful ensemble. Accented by the lush sword fern, variegated ti leaf, and lemon leaf, this arrangement is delivered in Teleflora's Clear Glass Cylinder vase, ensuring that every detail shines through. It's a perfect gift to brighten anyone's day.",
    price: '$76.00',
  },
  {
    img: Image3,
    title: 'Pitcher of Pink Harmony',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'Embrace the vibrant hues of friendship and affection with our delightful floral creation. This bouquet features hot pink roses, pink spray roses, soft pink alstroemeria, lively green carnations, and charming pink miniature carnations, beautifully complemented by bupleurum, lush leatherleaf fern, and the subtle fragrance of parvifolia eucalyptus. The heartwarming touch is the Heart Stone pitcher, making this arrangement a symbol of love and togetherness.',
    price: '$75.00',
  },
  {
    img: Image4,
    title: 'Pink Petals Delight',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      "Say hello to a burst of vibrant joy with our Pink Petals Delight bouquet! This charming arrangement features hot pink roses, pink spray roses, light pink alstroemeria, fresh green carnations, and dainty pink miniature carnations, all coming together in a colorful celebration. The addition of bupleurum, lush leatherleaf fern, and aromatic parvifolia eucalyptus adds an extra touch of natural beauty. Delivered in the Heart Stone pitcher, it's a heartwarming gift that's sure to make anyone's day a little brighter.",
    price: '$64.00',
  },
  {
    img: Image5,
    title: 'Sunny Splendor',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'The abundantly stunning floral ensemble comprises white daisy spray chrysanthemums, yellow daisy spray chrysanthemums, and bupleurum embellished with vibrant green foliage. It is thoughtfully presented in a radiant thoughtful vase.',
    price: '$54.00',
  },
  {
    img: Image6,
    title: 'Natural Elegance Arrangement',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'One-sided arrangement with peach roses, blue delphinium, white Peruvian lilies (alstroemeria) and daisy poms, purple statice; accented with assorted greenery Artistically designed in our exclusive grey washed wooden cube tied with raffia.',
    price: '$70.99',
  },
  {
    img: Image7,
    title: 'Seasonal Garden Harmony',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'A cheery vased assortment of garden fresh flowers, such as asiatic lilies, larkspur, asters, carnations, solidaster, spray mums, or similar seasonal favorites, in a bright vased bouquet',
    price: '$95.99',
  },
  {
    img: Image8,
    title: 'Woodland Serenity Bouquet',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'One-sided arrangement with peach roses, blue delphinium, white Peruvian lilies (alstroemeria) and daisy poms, purple statice; accented with assorted greenery Artistically designed in our exclusive grey washed wooden cube tied with raffia.',
    price: '$68.00',
  },
  {
    img: Image9,
    title: 'Rustic Elegance Delight',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'One-sided arrangement with peach roses, blue delphinium, white Peruvian lilies (alstroemeria) and daisy poms, purple statice; accented with assorted greenery Artistically designed in our exclusive grey washed wooden cube tied with raffia.',
    price: '$69.90',
  },
  {
    img: Image10,
    title: 'Blooms of Joyful Abundance',
    alt: 'Build a Floral Website with Customizable florist website and best floral website templates',
    category: 'Flower',
    description:
      'A cheery vased assortment of garden fresh flowers, such as asiatic lilies, larkspur, asters, carnations, solidaster, spray mums, or similar seasonal favorites, in a bright vased bouquet',
    price: '$69.00',
  },
];

const Catalog = () => {
  const [isLeftArrowDisabled, setIsLeftArrowDisabled] = useState(true);
  const [isRightArrowDisabled, setIsRightArrowDisabled] = useState(false);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    adaptiveHeight: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const sliderRef = useRef();

  const handleBeforeChange = (currentSlide, nextSlide) => {
    // Check if the left arrow should be disabled
    setIsLeftArrowDisabled(nextSlide === 0);

    // Check if the right arrow should be disabled
    const totalSlides = sliderRef.current.props.children.length;
    const slidesToShow = settings.slidesToShow;

    setIsRightArrowDisabled(nextSlide + slidesToShow >= totalSlides);
  };
  return (
    <Wrapper>
      <div className="container" style={{ paddingBottom: 0 }}>
        <div className="header d-flex flex-column align-items-center">
          <div className="slider-buttons">
            <LeftArrow
              onClick={() => sliderRef?.current?.slickPrev()}
              isDisabled={isLeftArrowDisabled}
            />
            <RightArrow
              onClick={() => sliderRef?.current?.slickNext()}
              isDisabled={isRightArrowDisabled}
            />
          </div>

          <h2>Floral Product Catalog</h2>
          <p>A Catalog of Floral Products contributed by Florists</p>
        </div>
      </div>
      <div className="container" style={{ paddingTop: 0, paddingRight: 0 }}>
        <div className="card-container">
          <Slider
            {...settings}
            ref={sliderRef}
            beforeChange={handleBeforeChange}
          >
            {products.map((item, index) => (
              <CatalogCard
                key={index}
                img={item.img}
                title={item.title}
                category={item.category}
                description={item.description}
                price={item.price}
                imgAlt={item.alt}
              />
            ))}
          </Slider>
        </div>
        {/* <ActionButton color="green">View All</ActionButton> */}
      </div>
    </Wrapper>
  );
};

export default Catalog;
